import parse from 'html-react-parser';
import type { ComponentProps } from 'react';

import { cn } from '../../lib/utils';
import { sanitizeDiffHtml } from './sanitize';

interface DiffRendererProps extends ComponentProps<'span'> {
  content?: string;
}

function DiffRenderer({ content, className, ...props }: DiffRendererProps) {
  if (!content) {return null;}

  const sanitized = sanitizeDiffHtml(content);

  return (
    <span
      data-slot={'diff-renderer'}
      className={cn(
        '[&_ins]:no-underline [&_ins]:bg-success-minimal [&_ins]:text-success',
        '[&_del]:line-through [&_del]:bg-destructive-minimal [&_del]:text-destructive',
        className
      )}
      {...props}
    >
      {parse(sanitized)}
    </span>
  );
}

export { DiffRenderer };
export type { DiffRendererProps };
